import { MisBuyerInterfApi } from 'rpc/MisBuyer/MisBuyer'
import { MisCommInterfApi } from 'rpc/MisComm/MisComm'
import { MisSellerInterfApi } from 'rpc/MisSeller/MisSeller'
import { LoginInterfApi } from 'rpc/Login/Login'
import { TableInterfApi } from 'rpc/Table/Table'
import { FormInterfApi } from 'rpc/Form/Form'
import { MisStoreInterfApi } from 'rpc/MisStore/MisStore'
import { FirmInterfApi } from 'rpc/Firm/Firm'
import { MisStatInterfApi } from 'rpc/MisStat/MisStat'
import { baseUrl } from '@/common/env'

class ApiUtil {
  constructor (store) {
    this.store = store
    this.handler = null
  }

  static install (store) {
    let apiUtil = new ApiUtil(store)
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.prototype.$apiUtil = apiUtil
      window.Vue.$apiUtil = apiUtil
    }
  }

  _getApi (Cls) {
    let api = new Cls(baseUrl)
    api.addHeader('client-id', this.store.state.clientid)
    api.addHeader('seller-companyid', this.store.getters.sellerCompanyid)
    api.addHeader('buyer-companyid', this.store.getters.buyerCompanyid)
    api.addHeader('buyer-userid', this.store.getters.buyerUserid)
    api.addHeader('manage-shopid', this.store.getters.buyerShopid)
    api.addHeader('app-type', this.store.state.appType)
    let oauth = this.store.state.userOauth
    if (oauth && oauth.access_token) {
      api.addHeader('access-token', oauth.access_token)
    }
    let userInfo = this.store.getters.userInfo
    let userid = 0
    if (userInfo && userInfo.userid) {
      userid = userInfo.userid
    }
    api.addHeader('userid', userid)
    let nickname = ''
    if (userInfo && userInfo.nickname) {
      nickname = userInfo.nickname
    }
    api.addHeader('nickname', window.btoa(encodeURI(nickname)))
    if (this.store.getters.sellerCustomid) {
      api.addHeader('seller-customid', this.store.getters.sellerCustomid)
    }
    if (this.handler) {
      let proxy = new Proxy(api, this.handler)
      return proxy
    } else {
      return api
    }
  }

  getMisBuyerApi () {
    return this._getApi(MisBuyerInterfApi)
  }

  getMisCommApi () {
    return this._getApi(MisCommInterfApi)
  }

  getMisSellerApi () {
    return this._getApi(MisSellerInterfApi)
  }

  getTableApi () {
    return this._getApi(TableInterfApi)
  }

  getFormApi () {
    return this._getApi(FormInterfApi)
  }

  getLoginApi () {
    return this._getApi(LoginInterfApi)
  }

  getMisStoreApi () {
    return this._getApi(MisStoreInterfApi)
  }

  getMisFirmApi () {
    return this._getApi(FirmInterfApi)
  }

  getMisStatApi () {
    return this._getApi(MisStatInterfApi)
  }

  setProxyHandler(handler) {
    this.handler = handler
  }
}

export default ApiUtil



// WEBPACK FOOTER //
// ./src/apis/apiutil.js